import { commits, getters } from '@/modules/core/app/helpers/store';

export const actions = {
  getCounter() {
    return getters.network.getCounter();
  },
  async track({}, promise) {
    commits.network.increment();
    try {
      await promise;
    } catch (e) {
      Logger.log(e);
    } finally {
      commits.network.decrement();
    }
  },
};
